export const FORMAT_OPTION = {
  NONE: 'none',
  DATE: 'date',
  NUMBER: 'number',
  NUMBER_SHORT: 'number_short',
  NUMBER_SHORTER: 'number_shorter',
  PERCENT: 'percent',
  PERCENT_SHORT: 'percent_short',
  PERCENT_SHORTER: 'percent_shorter'
}

export const FORMAT_OPTION_NUMBERS = [
  FORMAT_OPTION.NUMBER,
  FORMAT_OPTION.NUMBER_SHORT,
  FORMAT_OPTION.NUMBER_SHORTER
]

export const FORMAT_OPTION_PERCENTS = [
  FORMAT_OPTION.PERCENT,
  FORMAT_OPTION.PERCENT_SHORT,
  FORMAT_OPTION.PERCENT_SHORTER
]

export const DATE_FORMAT_OPTIONS = [
  { value: 'MMM YYYY', label: 'Jan 2020' },
  { value: 'MM-YYYY', label: '01-2020' },
  { value: 'YYYY-MM', label: '2020-01' },
  { value: '[Q]Q YYYY', label: 'Q1 2020' },
  { value: 'MMM', label: 'Jan' },
  { value: 'YYYY', label: '2020' },
  { value: 'MMM D, YYYY', label: 'Jan 31, 2020' },
  { value: 'MM-DD-YYYY', label: '01-31-2020' },
  { value: 'YYYY-MM-DD', label: '2020-01-31' }
]

class FormatOptionsService {
  formatOptionLabels = {
    none: 'None (1234)',
    date: 'Date',
    number: 'Number (12.345)',
    number_short: 'Short Number (12.34)',
    number_shorter: 'Shorter Number (12.3)',
    percent: 'Percent (12.345%)',
    percent_short: 'Short Percent (12.34%)',
    percent_shorter: 'Shorter Percent (12.3%)'
  }

  getFormatOptions (keys) {
    return keys.map((o) => ({ value: o, label: this.formatOptionLabels[o] }))
  }

  getLineBarMapFormatOptions (prop) {
    let keys = []
    switch (prop) {
      case 'xFormat':
        keys = ['none', 'date', ...FORMAT_OPTION_NUMBERS]
        break
      case 'yFormat':
      case 'y2Format':
      case 'yCIFormat':
      case 'valueType':
      case 'value2Type':
        keys = ['none', ...FORMAT_OPTION_NUMBERS, ...FORMAT_OPTION_PERCENTS]
        break
    }

    return this.getFormatOptions(keys)
  }

  getSelectedFormatOption (prop, value) {
    const formatOptions = this.getLineBarMapFormatOptions(prop)
    let option = formatOptions.find(({ value: v }) => v === value)
    if (value !== undefined && option === undefined) {
      option = { value, label: value }
    }
    return option
  }

  getDateFormatOptions (shouldAddCustom) {
    if (shouldAddCustom) {
      return [
        ...DATE_FORMAT_OPTIONS,
        { value: 'custom', label: 'Custom' }
      ]
    } else {
      return DATE_FORMAT_OPTIONS
    }
  }
}

export const formatOptionsService = new FormatOptionsService()
